import { useTranslation } from 'react-i18next'
import { Button, Modal } from '@boltenergy-be/design-system'
import { ConfirmationModalProps } from './types.ts'
import styles from './ConfirmationModal.module.scss'
import resources from 'translations/dutch'

const ConfirmationModal = ({ isOpen, state, setClose, onSubmit }: ConfirmationModalProps) => {
  // i18n
  const { t } = useTranslation('consumption')

  return (
    <Modal
      onRequestClose={setClose}
      isOpen={isOpen}
      className={styles.container}
      title={t(($) => $.editMeterReadings.confirmationModal.title)}
    >
      <p>
        {t(
          ($) =>
            $.editMeterReadings.confirmationModal.description[
              state.toLowerCase() as keyof typeof resources.consumption.editMeterReadings.confirmationModal.description
            ]
        )}
      </p>

      <div className={styles['actions-container']}>
        <Button variant="tertiary" onClick={() => setClose()}>
          {t(($) => $.cancel, {
            ns: 'common'
          })}
        </Button>
        <Button
          onClick={async () => {
            onSubmit()
            setClose()
          }}
        >
          {t(($) => $.confirm, {
            ns: 'common'
          })}
        </Button>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
